export default (countryCode: string) => {
  return !!countryCode && countryCode.toLowerCase() === "ca";
};
